import { RulesContext } from "@/context/RulesContext";
import React from "react";

export default function useRules() {
  return React.useContext(RulesContext);
}
